const ns = '[Pointer] ';

export const UPDATE_MOUSE_POSITION = `${ns}update mouse position`;
export const SET_MOUSE_OVER_CANVAS = `${ns}set mouse over canvas`;
export const RECORD_CLICK_STATE_ON_CANVAS = `${ns}record click state on canvas`;
export const UPDATE_LAST_CLICK_POS = `${ns}update last click pos`;
